import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { TechRadarClient } from '../../lib/TechRadarClient';

// PAT-1021: the tech-radar plugin is the upstream `/alpha` one, whose API
// extension is unnamed (`api:tech-radar`). This extension is unnamed too, so it
// gets the same id and replaces the plugin's default (backend-fetching) API
// instead of being rejected as a second factory for `techRadarApiRef`. Pinned
// by index.test.ts.
export const techRadarModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [
    ApiBlueprint.make({
      params: defineParams =>
        defineParams(createApiFactory(techRadarApiRef, new TechRadarClient())),
    }),
  ],
});
